import { isStringEmptyOrNull } from "../../../../utils/common";
import { MSG_EMPTY_REQUIRED, MSG_EXCEEDS_CHARACTER } from "../../../../utils/messages";

export const validateForm = (values) => {

    let errors = {};



    if (isStringEmptyOrNull(values.CandidateModel.choiceLabel)) {
        errors[`CandidateModel.choiceLabel`] = MSG_EMPTY_REQUIRED;
    } else if (255 < values.CandidateModel.choiceLabel.length) {
        errors[`CandidateModel.choiceLabel`] = MSG_EXCEEDS_CHARACTER;
    }

    if (isStringEmptyOrNull(values.CandidateModel.choiceDescription) || "<p></p>\n".toString() === values.CandidateModel.choiceDescription.toString()) {
        errors[`CandidateModel.choiceDescription`] = MSG_EMPTY_REQUIRED
    } else if (2500 < values.CandidateModel.choiceDescription.length) {
        errors[`CandidateModel.choiceDescription`] = MSG_EXCEEDS_CHARACTER;
    }


    return errors;

}